import { SCORING_PRIORITIES } from "../types/lead-priority";
import type { IScoringRuleDto, ScoringConfigRule } from "../types/scoring-config";

import { isScoringRuleAccountScoped } from "./isScoringRuleAccountScoped";

/**
 * Rules that apply to the current user:
 * - no teams → only account-scoped rules (Everyone in the account)
 * - at least one team → only rules whose teamIds intersect the user's (All teams + Specific teams)
 *
 * Used by Applicable for me, the non-admin board, lead scoring filters, and playbooks.
 */
export const isSharedScoringRuleVisibleToUserTeams = (
    rule: IScoringRuleDto,
    userTeamIds: ReadonlySet<number>,
): boolean => {
    if (isScoringRuleAccountScoped(rule.teamIds)) {
        return userTeamIds.size === 0;
    }

    return rule.teamIds!.some((teamId) => userTeamIds.has(teamId));
};

export const filterAccountRulesByTeamMembership = (
    accountRules: ScoringConfigRule,
    userTeamIds: ReadonlySet<number>,
): ScoringConfigRule => {
    const filtered: ScoringConfigRule = {};

    for (const priority of SCORING_PRIORITIES) {
        const column = (accountRules[priority] ?? []).filter(
            (rule) => rule.id && isSharedScoringRuleVisibleToUserTeams(rule, userTeamIds),
        );

        if (column.length > 0) {
            filtered[priority] = column;
        }
    }

    return filtered;
};
